import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Form } from 'react-bootstrap';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');

const ValidateUtil = require('../../util/ValidateUtil');

import ErrorBox from '../common/ErrorBox';



const propTypes = {
    show: PropTypes.bool,
    activity: PropTypes.object.isRequired,
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
    show: true,
};

class ActivityShortCourseMetadataModal extends React.Component {
    constructor(props) {
        super(props);
        this.firstInputElem = React.createRef();
        let md = props.activity && props.activity.short_course_meta_data || {};
        this.state = {
            desc1: md.desc1 || '',
            desc2: md.desc2 || '',
            ...ValidateUtil.getDefaultValidationState(),
        };
    }

    componentDidMount() {
        this.focusOnInput();
    }
    
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            ...ValidateUtil.getUpdatedStateFromNextProps(this.state, nextProps),
        });
    }
    

    onChangeTextField=(field_name,e)=>{
        this.setState({ [field_name]: e.target.value });
    }

    focusOnInput=()=>{
        const input = this.firstInputElem.current;
        if (!!input) {
            input.focus();
            
            if (!!this.props.defaultValue) {
                input.setSelectionRange(0, input.value.length);
            }
        }
    }
    
    submitHandler=()=>{
        let changes = {
            desc1: this.state.desc1,
            desc2: this.state.desc2,
        };
        this.props.submitHandler(changes);
    }

    render() {
        return (
            <Modal
                className='activity-short-course-meta-data-modal'
                show={this.props.show}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard={false}
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>{Strings['en'].short_course.modals.activity_shortcourse_metadata.TITLE}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.state.error} />
                    <Form>
                        <Form.Group>
                            <Form.Label>
                                {Strings['en'].short_course.modals.activity_shortcourse_metadata.DESC1_LABEL + ":"}
                            </Form.Label>
                            <textarea ref={this.firstInputElem} rows={6} columns={100}
                                value={this.state.desc1}
                                onChange={this.onChangeTextField.bind(this,'desc1')}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>
                                {Strings['en'].short_course.modals.activity_shortcourse_metadata.DESC2_LABEL + ":"}
                            </Form.Label>
                            <textarea rows={6} columns={100}
                                value={this.state.desc2}
                                onChange={this.onChangeTextField.bind(this,'desc2')}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.submitHandler} disabled={!!this.state.actionID}>
                        {Strings['en'].common.UPDATE}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

ActivityShortCourseMetadataModal.propTypes = propTypes;
ActivityShortCourseMetadataModal.defaultProps = defaultProps;

export default ActivityShortCourseMetadataModal;